import { Fab, Icon } from "@mui/material";
import React from "react";
import style from "./settings.module.scss";

const Title = (props) => {
  const { title, handleModal, enableButton } = props;
  return (
    <div className={style.header}>
      <span className={style.headetText}>{title}</span>
      {enableButton ? (
        <Fab
          variant="extended"
          aria-label="add"
          className={style.addButton}
          onClick={() => {
            if (handleModal) {
              handleModal(true, false);
            }
          }}
        >
          <Icon>add</Icon>
          ADD
        </Fab>
      ):null}
    </div>
  );
};

export default Title;
